import React, { useState, useEffect, useRef } from 'react';
import { useAsset } from '../../Data/Assets';

const AssetImage = ({ assetId, dimensions, className, alt, ...imgProps }) => {
    const { asset, isLoading, resize, isSaving } = useAsset(assetId);
    const [imageUrl, setImageUrl] = useState(null);
    const resizedUrlsRef = useRef({});
    const currentKeyRef = useRef(null);

    useEffect(() => {
        if (!assetId || !dimensions) {
            setImageUrl(null);
            return;
        }

        if (!asset) {
            return;
        }

        const cacheKey = `${assetId}-${dimensions}`;
        currentKeyRef.current = cacheKey;

        const cachedUrl = resizedUrlsRef.current[cacheKey];
        if (cachedUrl) {
            setImageUrl(cachedUrl);
            return;
        }

        if (asset.sizes && asset.sizes[dimensions]) {
            resizedUrlsRef.current[cacheKey] = asset.sizes[dimensions];
            setImageUrl(asset.sizes[dimensions]);
            return;
        }

        resize(dimensions).then(response => {
            if (response?.url && currentKeyRef.current === cacheKey) {
                resizedUrlsRef.current[cacheKey] = response.url;
                setImageUrl(response.url);
            }
        });
    }, [assetId, dimensions, asset, resize]);

    const isLoadingState = isLoading || isSaving;

    if (!assetId) {
        return <div className={`${className || ''} border border-gray-200 rounded-md flex items-center justify-center bg-gray-100`}>
            <span className="text-xs text-muted">No image</span>
        </div>;
    }

    if (isLoadingState) {
        return <div className={`${className || ''} border border-gray-200 rounded-md flex items-center justify-center bg-gray-100`}>

        </div>;
    }

    if (!imageUrl) {
        return <div className={`${className || ''} border border-gray-200 rounded-md flex items-center justify-center bg-gray-100`}>
            <span className="text-xs text-muted">Image not found</span>
        </div>;
    }

    return <img
        src={imageUrl}
        alt={alt || asset?.description || assetId}
        className={className}
        {...imgProps}
    />;
};

export default AssetImage;
